// extracted by mini-css-extract-plugin
module.exports = {"root":"_1ApMI","bg":"_3cHlA"};